export default "__VITE_PUBLIC_ASSET__acc41e1c__"